import axios from 'axios'

export default axios.create({
    baseURL: 'https://secureapi.lpn.co.th/AuthenLPN'
})